import TileLayer from 'ol/layer/Tile';
import { BasemapSource } from '../../bgis/ol/source/BasemapSource';


export const basemapOrthofotoLayer = new TileLayer({
        source: new BasemapSource({ variant: 'bmaporthofoto30cm' }),
        visible: false,
    })
 


